module.exports = __webpack_public_path__ + "static/img/guide.b462dd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide.png
// module id = vG7k
// module chunks = 1